module.exports = __webpack_public_path__ + "img/avatar_3@2x.441dc947.png";